import React from 'react';
import { Gap, Icon, Link } from '@common/components';
import { useCurrentMembership } from '@identity/hooks';
import { buildDialogUrl } from '@common/services';

export function ProfileStatusSetupLink({
  assignmentId,
  applicationId,
  doNotRehire,
  profileIdentificationCode,
}: {
  assignmentId?: string;
  applicationId?: string;
  doNotRehire: boolean;
  profileIdentificationCode: string;
}) {
  const currentMembership = useCurrentMembership();

  if (!profileIdentificationCode) {
    return null;
  }

  const profileStatusSetupApplicationDrawerUrl = buildDialogUrl(
    'profile-status-setup-application-drawer',
    {
      props: {
        applicationId: applicationId || '',
      },
    }
  );

  const profileStatusSetupAssignmentDrawerUrl = buildDialogUrl(
    'profile-status-setup-assignment-drawer',
    {
      props: {
        assignmentId: assignmentId || '',
      },
    }
  );

  const drawerUrl = assignmentId
    ? profileStatusSetupAssignmentDrawerUrl
    : profileStatusSetupApplicationDrawerUrl;

  const label = doNotRehire ? 'Do Not Rehire' : 'Eligible for Resubmission';

  return (
    <div className="profile-status-setup-link">
      <Gap align="center">
        <Icon
          icon={doNotRehire ? 'userXmark' : 'userCheck'}
          kind="light"
          size="sm"
          tooltipText={
            doNotRehire
              ? 'Not Eligible for Resubmission'
              : 'Eligible for Resubmission'
          }
        />
        {currentMembership.canShowWorkerStatus ? (
          <Link to={drawerUrl}>{label}</Link>
        ) : (
          <>{label}</>
        )}
      </Gap>
    </div>
  );
}
